<script>
/**
 * Descripción: Pantalla Clientes Filtro
 *
 * @displayName PartnerByCustomerFilterViewComponent
 */

import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';
import httpService from '@/services/httpService.js';

const BaseServerDataTable = () =>
  import('@/components/core/grids/BaseServerDataTable.vue');

export default {
  name: 'PartnerByCustomerFilterViewComponent',

  components: {
    BaseServerDataTable
  },

  props: {
    /**
     * Enviar información adicional al servidor
     */
    extraParams: {
      type: Object,
      default: undefined
    },

    /**
     * Función Nuevo
     * Default undefined
     */
    fnNew: {
      type: Function,
      default: undefined
    }
  },

  computed: {
    /**
     * Configuracion BaseServerDataTable
     */
    setting() {
      return {
        controller: 'PartnerByCustomer',
        method: 'Filter',
        columns: [
          {
            text: 'Partner',
            align: 'start',
            value: 'partnerName',
            show: true
          },
          {
            text: 'Cliente',
            align: 'start',
            value: 'customerName',
            show: true
          }
        ],
        key:
          this.extraParams.partnerId != undefined ? 'customerId' : 'partnerId'
      };
    }
  },

  methods: {
    $_refresh() {
      this.$refs.customerContactFilter.$_ParamsToAPI();
      this.$refs.customerContactFilter.$data.selected = [];
    },

    /**
     * Eliminar Objecto
     */
    $_delete(params) {
      let object = BaseArrayHelper.SetObject({}, params[0]);
      httpService.post('PartnerByCustomer/Delete', [object]).then(response => {
        if (response != undefined) {
          //Logica JS luego de la acción exitosa!!!
          this.$refs.customerContactFilter.$_ParamsToAPI();
        }
      });
    }
  }
};
</script>

<template>
  <div>
    <!-- @BaseServerDataTable -->
    <BaseServerDataTable
      ref="customerContactFilter"
      :extraParams="extraParams"
      :setting="setting"
      :fnNew="fnNew"
      :fnDelete="$_delete"
    />
  </div>
</template>
